import { useQuery } from '@tanstack/react-query';
import { ApiClient } from 'lib/api/client';
import { useStore } from 'lib/store';
import { QUERY_KEYS } from 'settings/config';
import { useApiReady } from './use-api-ready';

import { useEffect } from 'react';
import { usePwaConfig } from './use-pwa-config';

import { signOut } from 'next-auth/react';

/** Get the active buyer org */
export function useBuyerOrg() {
  const enabled = useApiReady();
  const { config } = usePwaConfig();
  const activeBuyerOrgId = useStore((store) => store.activeBuyerOrgId);
  const setActiveBuyerOrgId = useStore((store) => store.setActiveBuyerOrgId);
  const removeActiveBuyerOrgId = useStore(
    (store) => store.removeActiveBuyerOrgId
  );

  useEffect(() => {
    if (config?.org_id && activeBuyerOrgId !== config.org_id) {
      setActiveBuyerOrgId(config.org_id);
    }
  }, [config, activeBuyerOrgId, setActiveBuyerOrgId]);

  return useQuery(
    [QUERY_KEYS.org, activeBuyerOrgId],
    () =>
      new ApiClient().organisationApi.orgRetrieve({
        buyerOrgId: activeBuyerOrgId || '',
      }),
    {
      select: (data) => data.data,
      enabled: enabled && !!activeBuyerOrgId,
      onError: (error: any) => {
        console.log('error', error);
        if (error?.response?.status === 404) {
          removeActiveBuyerOrgId();
          signOut({ callbackUrl: '/unauthorized' });
        } else {
          removeActiveBuyerOrgId();
        }
      },
    }
  );
}
